import ExpenseForm from './ExpenseForm';

const Expenses = () => {
  return <ExpenseForm />;
};

export default Expenses;
